module.exports = __webpack_public_path__ + "static/img/8areaB_09.bbbb89a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_09.png
// module id = 1238
// module chunks = 1